var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row home-event-list",on:{"click":_vm.navigate}},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.data.title))]),_c('div',{staticClass:"count"},[_vm._v(_vm._s(_vm.data.count)+"条相关新闻")])]),_c('div',{staticClass:"right"},[_c('span',{staticClass:"index"},[_vm._v(_vm._s(_vm.data.heat))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }